module.exports = __webpack_public_path__ + "media/im_hero_bg.b396932a.mp4";